var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleWebDesigner1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.844,
    height: 52,
    viewBox: "0 0 44.844 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15766",
    "data-name": "Group 15766",
    transform: "translate(-50.847 -98.849)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15766-2",
    "data-name": "Group 15766",
    transform: "translate(50.847 98.849)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19659",
    "data-name": "Path 19659",
    d: "M79.8,379.533q-.006,8.127,0,16.254c0,.374-.078.507-.476.5a28.714,28.714,0,0,1-10.961-2.3A28.875,28.875,0,0,1,52.06,376.046a25.787,25.787,0,0,1-1.213-7.795c0-.372.086-.5.481-.494,1.145.019,2.291-.009,3.437-.019.159.011.318.032.476.032q4.7,0,9.407,0c1.044,0,2.089-.016,3.133-.024l.337.028a11.826,11.826,0,0,0,11.6,11.673Z",
    transform: "translate(-50.847 -344.289)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19660",
    "data-name": "Path 19660",
    d: "M110.3,122.337l-.337-.028c-.591-.112-1.183-.22-1.774-.336-2.914-.572-5.826-1.152-8.742-1.715-.791-.153-1.593-.253-2.39-.378.276-1.391.453-2.812.846-4.169A23.08,23.08,0,0,1,115.886,99.4c1.4-.265,2.84-.365,4.325-.549.014.286.028.438.028.591,0,1.032,0,2.064,0,3.1a3.289,3.289,0,0,0,.068.463c-.016.216-.044.433-.044.649q-.006,4.356-.006,8.712c-.188.01-.377.019-.565.031a9.863,9.863,0,0,0-6.2,2.54A9.607,9.607,0,0,0,110.3,122.337Z",
    transform: "translate(-93.026 -98.849)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19661",
    "data-name": "Path 19661",
    d: "M366.672,148.322a20.113,20.113,0,0,1,5.446,1.883,16.965,16.965,0,0,1,9.189,12.219,15.062,15.062,0,0,1,.353,3.846h-8.8l-.088-.011-.094-.066-.01-.03-.052-.437c-.037-.346-.057-.694-.115-1.037a7.908,7.908,0,0,0-4.372-6.164,10.637,10.637,0,0,0-3.977-1.012,4.463,4.463,0,0,1,.081-.637c.37-1.363.745-2.725,1.134-4.083C365.792,151.3,366.235,149.812,366.672,148.322Z",
    transform: "translate(-336.828 -144.008)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19662",
    "data-name": "Path 19662",
    d: "M389.035,354l.088.011c.136.067.271.14.41.2,1,.441,2,.891,3.006,1.317.568.24,1.154.437,1.732.654-.243.859-.422,1.743-.743,2.572a13.207,13.207,0,0,1-3.026,4.619,11.762,11.762,0,0,1-6.49,3.356c-.654.109-1.314.177-1.971.263l-.073-.083q0-.089.007-.178h.082a1.741,1.741,0,0,0,.255-.334c.44-1.009.867-2.023,1.3-3.034q.7-1.633,1.413-3.264a8.419,8.419,0,0,0,2.108-1.708,6.845,6.845,0,0,0,1.806-4.375Z",
    transform: "translate(-353.093 -331.746)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19663",
    "data-name": "Path 19663",
    d: "M95.894,340.022c.8.125,1.6.225,2.39.378,2.916.562,5.828,1.143,8.742,1.715.59.116,1.182.224,1.774.336-1.044.008-2.089.023-3.133.024q-4.7,0-9.407,0c-.159,0-.318-.021-.476-.032Z",
    transform: "translate(-91.864 -318.99)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19664",
    "data-name": "Path 19664",
    d: "M365.767,146.59c-.436,1.49-.88,2.978-1.307,4.47-.389,1.358-.763,2.72-1.134,4.083a4.485,4.485,0,0,0-.081.637l-.086,0q0-4.356.006-8.712c0-.216.029-.433.044-.649Z",
    transform: "translate(-335.924 -142.275)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19665",
    "data-name": "Path 19665",
    d: "M469.156,356.3c-.578-.217-1.164-.414-1.732-.654-1.008-.425-2.005-.875-3.006-1.317-.139-.061-.273-.134-.41-.2h5.5Z",
    transform: "translate(-427.978 -331.864)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19667",
    "data-name": "Path 19667",
    d: "M461.264,348.326l-.052-.437Z",
    transform: "translate(-425.426 -326.171)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19668",
    "data-name": "Path 19668",
    d: "M461.834,353.324a.1.1,0,0,1,0-.081l.094.066Z",
    transform: "translate(-425.985 -331.059)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19669",
    "data-name": "Path 19669",
    d: "M382.052,430.307q0-.174,0-.348c.01-.008.029-.019.028-.025a.354.354,0,0,0-.024-.065c0-1.636,0-3.273-.012-4.909,0-.287.058-.385.4-.37a5.289,5.289,0,0,0,2.653-.656q-.707,1.632-1.413,3.264c-.435,1.011-.862,2.025-1.3,3.034a1.743,1.743,0,0,1-.255.334Z",
    transform: "translate(-353.162 -395.586)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19670",
    "data-name": "Path 19670",
    d: "M382.057,497l.074.26h-.082Q382.053,497.133,382.057,497Z",
    transform: "translate(-353.166 -462.281)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19671",
    "data-name": "Path 19671",
    d: "M382.136,491.981a.353.353,0,0,1,.024.065c0,.006-.018.017-.028.025C382.133,492.041,382.135,492.011,382.136,491.981Z",
    transform: "translate(-353.242 -457.698)",
    fill: "#1a1a1a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleWebDesigner1);
export default __webpack_public_path__ + "static/media/google-web-designer (1).9a827e1e0cb1f8b171f2573165cc6d0c.svg";
export { ForwardRef as ReactComponent };